module.exports = __webpack_public_path__ + "static/img/main@w.bf08fdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-chem-pr-portal/main@w.png
// module id = 1X+I
// module chunks = 0